// Module
var code = `<div class="header-content">
  <div class="branding">
    <div class="site-title">
      <h1>
        <a
          href="/"
          aria-label="Home"
          class="logo-link"
          data-channel="ROUTE"
          data-end-route="true"
          data-page-id="home"
          data-event-prevent-default="true"
        >
        </a>
        <svg style="height:20px; margin-top:-3px;" id="spyne-logo" data-name="Layer 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 22">
          <g>
            <path d="M46,10.8l-5.9-9.5c-.9-1.2-2.8,0-2.1,1.4l6.7,10.7c.2,1.9-.2,4.3,0,6.2s2.3,1.3,2.4.2c.3-1.9-.2-4.4,0-6.3l7.1-10.9c.7-1.3-1.3-2.5-2.1-1.2l-6.3,9.4ZM5.5.9C1.7,1.3.7,5,1.5,8.2c1.1,4.6,5.9,3.2,9.3,3.5s3,1.7,2.8,4.1-.6,2-1.9,2.3-5.9.3-7.2,0c-2.1-.6-.9-2.9-2.8-2.8s-.8,2.9,0,3.8,1.9,1.3,2.9,1.5c1.9.3,7.4.3,9.1-.5,3.6-1.7,3.5-9-.4-10.4s-6.5.2-8.3-.7-1.1-2.6-1-3.6.9-1.9,2.3-2,4.8-.1,5.8.2c1.6.5,1,2.3,2.1,2.4,2.3.4,1.7-1.9.9-3.1s-1.4-1.4-2.3-1.7c-1.3-.4-5.6-.4-7.1-.2ZM71.8,15.9L60.2,1.1c-.9-.6-2-.3-2,.9v17.6c0,1,1.2,1.4,2,.9s.4-.5.4-.6V5.7l11.4,14.5c.8.8,2.1.7,2.3-.5V1.8c-.2-1.5-2.4-1.1-2.4-.2v14.3ZM81.7,3.3h9.6c.1,0,.6-.3.7-.4.4-.6.2-1.9-.6-2h-11.2c-.6,0-.9.6-.9,1.1v17.5c0,.6.3,1.1.9,1.2h11.1c.9,0,1.2-1.1.9-1.8s-.5-.6-.7-.6h-9.8v-6.3h6.3c0,0,.5-.3.6-.4.5-.6.2-2-.6-2h-6.3V3.3Z" ></path>
            <path d="M71.8,15.9V1.6c0-.9,2.2-1.3,2.4.2v17.8c-.2,1.2-1.5,1.3-2.3.5l-11.4-14.5v14.3c0,0-.3.5-.4.6-.8.5-2,0-2-.9V2c0-1.1,1.2-1.4,2-.9l11.6,14.8Z" ></path>
            <path d="M5.5.9c1.5-.2,5.7-.2,7.1.2s1.8.9,2.3,1.7c.8,1.2,1.4,3.5-.9,3.1s-.5-1.9-2.1-2.4-4.6-.3-5.8-.2-2.1.6-2.3,2-.1,3.1,1,3.6c1.8.9,5.9-.2,8.3.7,3.9,1.5,4.1,8.7.4,10.4s-7.2.8-9.1.5-2.2-.7-2.9-1.5-2-3.7,0-3.8.8,2.2,2.8,2.8,5.9.3,7.2,0,1.8-.9,1.9-2.3c.2-2.4,0-3.9-2.8-4.1s-8.2,1.1-9.3-3.5c-.8-3.2.2-6.9,4-7.3Z" ></path>
            <path d="M81.7,3.3v6h.1c0,.1,6.2.1,6.2.1.8,0,1,1.4.6,2s-.5.4-.6.4h-6.3v6.2h.1c0,.1,9.7.1,9.7.1.1,0,.6.5.7.6.3.7,0,1.7-.9,1.8h-11.1c-.7-.1-.9-.6-.9-1.2V2c0-.6.4-1.1.9-1.1h11.2c.9,0,1.1,1.4.6,2s-.6.4-.7.4h-9.6Z" ></path>
            <path d="M46,10.8l6.3-9.4c.8-1.3,2.9,0,2.1,1.2l-7.1,10.9c-.3,1.9.3,4.4,0,6.3s-2.2,1.3-2.4-.2.2-4.3,0-6.2l-6.7-10.7c-.8-1.3,1.2-2.6,2.1-1.4l5.9,9.5Z" ></path>
          </g>
          <path d="M22.3.9c-.4,0-.8.4-.9.7v18.1c0,1,1.2,1.3,2,.9.1,0,.4-.5.4-.6v-7.2h6.6c2.9,0,4.5-2.6,4.6-5.2.5-8.8-6.8-6.3-12.8-6.7ZM32.5,8c0,1-.5,1.8-1.5,2.1-.2,0-.9.2-1,.2h-6.2V3.3h6.5c.3,0,1.2.4,1.5.6.9.8.8,2.9.8,4Z" ></path>
        </svg>
        <span></span>
      </h1>
    </div>
    <!-- Insert Nav -->
  </div>
</div>
`;
// Exports
module.exports = code;